import "./Gifts.css";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import GiftsContainer from "./GiftsContainer";
import { getCountry } from "../utils/getCountry";

const Gifts = ({ selectedCountry }) => {
  selectedCountry = getCountry(selectedCountry);
  const location = useLocation();
  const [productList, setProductList] = useState([]);
  const [currentPageProductList, setCurrentPageProductList] = useState(null);
  const [occasionStr, setOccasionStr] = useState("");
  const [backgroundImageUrl, setBackgroundImageUrl] = useState("");
  const [loadingError, setLoadingError] = useState("");
  const [currentIndexes, setCurrentIndexes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const numberGiftsPerPage = 16;
  const updateCurrentPageProductList = () => {
    let startIndex = (currentPage - 1) * numberGiftsPerPage;
    let endIndex = currentPage * numberGiftsPerPage;

    const slicedArray = productList.filter(
      (item) => item.id - 1 >= startIndex && item.id - 1 < endIndex
    );
    setCurrentPageProductList(slicedArray);
    setLoadingError("");
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const occasion = queryParams.get("occasion");
    try {
      const jsonData = require(`../data/occasions/${selectedCountry}/${occasion}.json`);
      setOccasionStr(jsonData.occasion);
      setBackgroundImageUrl(jsonData.backgroundImageUrl);
      setProductList(jsonData.productList);
      setCurrentIndexes(jsonData.productList.map(() => 0));
      if (productList.length % numberGiftsPerPage === 0) {
        setTotalPages(productList.length / numberGiftsPerPage);
      } else {
        setTotalPages(Math.floor(productList.length / numberGiftsPerPage) + 1);
      }
      updateCurrentPageProductList();
    } catch (err) {
      setLoadingError("More gifts coming soon...");
    }
  }, [selectedCountry, location, currentPage, productList]);

  const goToPreviousPage = () => {
    if (currentPage <= 1) {
      return;
    }
    setCurrentPage(currentPage - 1);
    updateCurrentPageProductList();
  };

  const goToNextPage = () => {
    if (currentPage >= totalPages) {
      return;
    }
    setCurrentPage((prevCurrentPage) => prevCurrentPage + 1);
    updateCurrentPageProductList();
  };

  if (loadingError !== "" || currentPageProductList === null) {
    return (
      <div>
        <p
          style={{
            justifySelf: "center",
            height: "100vh",
            alignContent: "center",
            fontSize: "22px",
            fontWeight: "bold",
          }}
        >
          {loadingError}
        </p>
      </div>
    );
  }

  return (
    <div>
      <div>
        <h2
          style={{
            justifySelf: "center",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          Find best {occasionStr} gifts for your loved ones.
        </h2>
      </div>
      <div>
        <GiftsContainer
          productList={currentPageProductList}
          backgroundImageUrl={backgroundImageUrl}
          currentIndexes={currentIndexes}
          setCurrentIndexes={setCurrentIndexes}
        />
      </div>
      <div>
        <p
          style={{
            justifySelf: "center",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <span
            style={{
              color: currentPage === 1 ? "gray" : "black",
              marginRight: 10,
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
            onClick={() => goToPreviousPage()}
          >
            &#9664; {/* Left arrow */}
          </span>
          Page {currentPage} / {totalPages}
          <span
            style={{
              color: currentPage === totalPages ? "gray" : "black",
              marginLeft: 10,
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
            onClick={() => goToNextPage()}
          >
            &#9654; {/* Right arrow */}
          </span>
        </p>
      </div>
    </div>
  );
};

export default Gifts;
